import React, { Component } from "react";

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        data-name="1c51936f-ad83-4493-a1e8-5a7ca1846cda"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1164.01 556"
      >
        <defs>
          <linearGradient
            id="a"
            x1={439.36}
            y1={2121.53}
            x2={439.36}
            y2={2121.53}
            gradientTransform="translate(-17.96 -1614.03)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="gray" stopOpacity={0.25} />
            <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
            <stop offset={1} stopColor="gray" stopOpacity={0.1} />
          </linearGradient>
          <linearGradient
            id="b"
            x1={187.14}
            y1={1975.72}
            x2={458.16}
            y2={1975.72}
            xlinkHref="#a"
          />
          <linearGradient
            id="c"
            x1={-1193.52}
            y1={2147.93}
            x2={-1193.52}
            y2={1825.2}
            gradientTransform="translate(1979.37 -1614.03)"
            xlinkHref="#a"
          />
        </defs>
        <path
          d="M1155.2 461.1a82.94 82.94 0 01-23 27.6c-1.4 1.1-2.8 2.1-4.2 3.2-1.9 1.3-3.8 2.6-5.8 3.9-15.5 9.8-33.6 16.5-51.3 21.4-4.8 1.3-9.7 2.6-14.5 3.8-4.1 1-8.2 1.9-12.3 2.8-1.6.3-3.1.7-4.7 1s-3.3.7-5 1l-2.4.5c-45.8 8.4-92.2 10.1-139 7.9l-2.2-.1-3.5-.2c-9.5-.5-19-1.1-28.5-1.9l-3.6-.3-1.6-.1c-5.3-.4-10.7-.9-16-1.5-7-.7-14.1-1.4-21.1-2.2l-.9-.1-.7-.1c-25.2-2.8-50.4-6.2-75.6-9.7l-3.6-.5-6.4-.9-5.4-.8-1.6-.2c-8.5-1.2-17-2.4-25.6-3.5l-1.4-.2c-16-2.2-32.1-4.3-48.1-6.2l-2.1-.3c-6.6-.8-13.1-1.5-19.7-2.2l-5-.5-6.7-.7c-18.4-1.8-36.8-3.3-55.2-4.2-8.8-.4-17.7-.8-26.6-1-7.3-.2-14.7-.3-22-.3-9.9 0-19.9 0-29.9.2h-2.3c-14.1.2-28.2.6-42.3 1.1l-2.5.1h-.9c-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-6.2l-4.6.1c-4.8 0-9.6.1-14.4.1h-5.9c-17.6 0-35.2-.4-52.6-1.3l-1.9-.1c-33.9-1.8-67.4-5.6-100.3-12.5-3.4-.7-6.8-1.5-10.2-2.2a471.84 471.84 0 01-66.8-20.3c-10.2-4-20.5-8.6-28.3-16.4-19.8-20-12.3-59.2 13.4-70.6 20.1-8.9 43.7-1.7 65.3-5.7 1.3-.3 2.6-.6 3.9-1a61.27 61.27 0 008-3.3c.9-.4 1.8-.9 2.7-1.4 2-1.1 4-2.3 5.9-3.6 3.1-2.1 6.1-4.4 9-6.8 1.3-1.1 2.5-2.2 3.7-3.4a68.38 68.38 0 0010.9-13.1 60.23 60.23 0 003-5.6 19.78 19.78 0 001.2-3.1 34.47 34.47 0 001.2-4.6c1.3-7.4-.8-14.7-7.9-20.8-.6-.5-1.3-1-2-1.5a26.69 26.69 0 00-4.3-2.5 10.84 10.84 0 00-1.9-.8c-9.1-3.9-20.9-5.3-30.9-8a54 54 0 01-8.8-3.1c-1.8-.8-3.6-1.7-5.4-2.6l-.5-.3a120.71 120.71 0 01-39-32 123.25 123.25 0 01-7.3-10.5 37.18 37.18 0 01-1.9-3.4c-17.6-31.7-19.4-72.3-1.1-103.5a99.49 99.49 0 017.4-10.9c.9-1.1 1.8-2.3 2.7-3.4C56 103.6 81 89.7 106.3 79.4c33.9-13.8 69.4-22.6 105.5-28.3 7.3-1.2 14.7-2.2 22-3.1 30.7-3.9 61.8-6 92.6-7.6q43.2-2.25 86.9-2.8c9.9-.1 19.7-.2 29.6-.2 22.3 0 44.5.4 66.8 1.3 7.3.3 14.7.6 22 1q28.2 1.5 56.3 4c9 .8 18 1.7 26.9 2.7 68.2 7.5 135.5 20.1 200.4 39.8 7.4 2.2 14.7 4.6 22 7a861 861 0 0180.4 31.1c2.5 1.1 5 2.2 7.4 3.4q24.6 11.3 48.5 24.3a535.12 535.12 0 0160.6 38c7.5 5.5 14.9 11.3 22 17.3a318.57 318.57 0 0135.1 34.6c1 1.1 1.9 2.2 2.8 3.4 4.9 5.9 9.5 11.9 13.9 18.2 21.4 30.8 35.8 65.9 46.4 101.9 9.4 31.2 15.6 66.4.8 95.7z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          fill={theme.imageHighlight}
          opacity={0.10000000149011612}
        />
        <path
          d="M1141.8 353.8h-85.4V245.1h38c-.9-1.1-1.9-2.2-2.8-3.4h-35.1v-34.6c-7.1-6-14.4-11.8-22-17.3v52h-197V127.5h87.8c-2.5-1.1-4.9-2.2-7.4-3.4h-80.4V93c-7.3-2.4-14.7-4.8-22-7v38H534.3l-.7-.6L615 46.2c-9-1-17.9-1.9-26.9-2.7L531.7 97V39.6c-7.3-.4-14.7-.7-22-1v62.1L443 37.3c-9.9 0-19.7.1-29.6.2l90.6 85.9-.7.6H233.8V48c-7.3.9-14.7 2-22 3.1v73H38.6c-.9 1.1-1.8 2.2-2.7 3.4h175.9v114.3H29.6c.6 1.1 1.3 2.3 1.9 3.4h180.3v108.7h-88.7c-1.2 1.2-2.4 2.3-3.7 3.4h92.4v111.2c7.3 1 14.7 2.1 22 3.3V357.1h275.9v139.3c7.3 0 14.7.1 22 .3V357.1h283.7v170.6l.9.1c7 .8 14.1 1.5 21.1 2.2V357.1h196.9v168.6c1.7-.3 3.4-.6 5-1s3.1-.6 4.7-1c4.1-.9 8.2-1.8 12.3-2.8V357.1h86.1zm-632.1 0H233.8V245.1h275.9zm0-112H233.8V127.5h272l3.9 3.1zm305.7 112H531.7V245.1h283.7zm0-112H531.7V127.5h283.7zm218.9 112H837.4V245.1h196.9z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          fill={theme.imageHighlight}
          opacity={0.10000000149011612}
        />
        <path
          d="M297.2 507.2c0 .1-.1.2-.1.3 0-.1.1-.2.1-.3zM302.4 502.4h-6.2l-4.6.1-.5-5.3-.5-5-2.2-22.8-.1-.7v-.3l-.6-6.4 9.3-3.5 1.1 9.3.1.7v.1l2.3 18.9.7 5.8.4 3.4.4 2.9v.1z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          fill="#3a3768"
          d="M335.85 507.2L335.95 507.5 335.25 507.5 335.15 507.2 335.85 507.2z"
        />
        <path
          d="M480.8 375.4v.4s-8.7 23.8-11.6 44.2c-.2 1.3-.4 2.7-.5 4s-.3 2.8-.3 4.1c-.1 1.6-.1 3.1-.1 4.5v1c0 .7.1 1.4.1 2.1a18 18 0 00.2 2.2c.1.8.1 1.4.2 2.1 2.1 22 10.3 54.2 10.3 54.2s.3.9.6 2.3h-2.3c-14.1.2-28.2.6-42.3 1.1l-2.5.1h-.8c-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-2.8a15.46 15.46 0 012.4-2.7 23.48 23.48 0 012.5-1.9 53.91 53.91 0 0115.4-6.6 10.2 10.2 0 013.5-.4l7 .1h1.1l10.7.2 92.1 1.8h.2l.6-.1a16.29 16.29 0 003.1-1.1 11.12 11.12 0 006.6-8.5c0-.3.1-.6.1-1v-1.5a4.48 4.48 0 00-.1-1.1c-.1-.4-.1-.7-.2-1.1-2.2-12.4-6-50.6-6-50.6v.1s0-1.6.1-4.4v-1.3c0-.6.1-1.3.1-2 0-.4.1-.9.1-1.3a14.92 14.92 0 01.2-2.1v-.1c0-.5.1-.9.1-1.4.1-.7 0-.1 0-.2 1.5-14.8 6.2-38.1 21-46.8 7-4.1 11.5-4.9 14.6-4.1 4.4 1.2 5.5 5.8 5.8 8.8v.6a8.08 8.08 0 01.3 1.9z"
          transform="translate(-.05)"
          fill="#3a3768"
        />
        <path
          d="M297.2 507.2c0 .1-.1.2-.1.3 0-.1.1-.2.1-.3z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M335.85 507.2L335.95 507.5 335.25 507.5 335.15 507.2 335.85 507.2z"
        />
        <path
          d="M480.8 375.4v.3s-7.2 19.7-10.6 38.5c-.2 1.3-.5 2.6-.7 3.9-.1.6-.2 1.3-.3 1.9-.2 1.3-.4 2.7-.5 4s-.3 2.8-.3 4.1c-.1 1.6-.1 3.1-.1 4.5v1c0 .7.1 1.4.1 2.1a18 18 0 00.2 2.2c.1.8.1 1.4.2 2.1s.1 1.4.2 2.1c.3 2.8.7 5.8 1.2 8.8 3.1 20.4 8.9 43.2 8.9 43.2a20.93 20.93 0 01.6 2.5h-2.3c-14.1.2-28.2.6-42.3 1.1l-2.5.1h-.8c-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-2.9a16.68 16.68 0 012.5-2.8 15 15 0 012.5-1.9 53.91 53.91 0 0115.4-6.6 13.42 13.42 0 013.5-.4l7 .1h1.1l10.8.2 92.2 1.8h.2a1.73 1.73 0 00.7-.2 16.29 16.29 0 003.1-1.1 11.07 11.07 0 006.5-8.3c0-.3.1-.6.1-1v-1.5a4.48 4.48 0 00-.1-1.1c-.1-.4-.1-.8-.2-1.2-2.2-12.4-6-50.6-6-50.6s0-1.6.1-4.4V422c0-.6.1-1.3.1-2 0-.4.1-.9.1-1.3a14.92 14.92 0 01.2-2.1v-.1c0-.5.1-.9.1-1.4.1-.7 0-.1 0-.2.2-1.8.4-3.8.7-5.9 2.1-14.5 7.3-33.4 20.2-41 6.8-4 11.3-4.8 14.3-4.2 4.7 1.1 5.8 5.9 6 8.9v.6a8.81 8.81 0 01.3 2.1z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M297.2 507.2c0 .1-.1.2-.1.3 0-.1.1-.2.1-.3z"
          transform="translate(-.05)"
          fill="#3a3768"
        />
        <path
          fill="#3a3768"
          d="M335.85 507.2L335.95 507.5 335.25 507.5 335.15 507.2 335.85 507.2z"
        />
        <path
          d="M478.2 374.6s-13 35.7-12.4 57 10.8 61.4 10.8 61.4.4 1.4.9 3.7c-14.1.2-28.2.6-42.3 1.1l-2.5.1h-.8c-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-6.2a19 19 0 015.5-5.8l.3-.2a54 54 0 0115.3-6.4 13.42 13.42 0 013.5-.4l9.2.2h1.1l11.1.2 89.8 1.8a12.34 12.34 0 003.7-1.2 10.91 10.91 0 001.1-.6 11.75 11.75 0 003-2.5c1.9-2.2 3.1-5.3 2.3-10-2.2-12.4-6-50.6-6-50.6s-.6-46.5 21.6-59.5c9-5.3 14.1-5.1 16.9-3 .1.1.2.1.2.2 4.1 3 3.4 10 3.4 10z"
          transform="translate(-.05)"
          fill="#3a3768"
        />
        <path
          d="M119.1 462.1l-.4 3.7-2.2 22.9c-3.4-.7-6.8-1.5-10.2-2.2l2.6-20.8.9-7.1z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          fill="#efc6cd"
          d="M55.05 454.7L109.55 338.8 328.95 355.9 349.15 454.7 55.05 454.7z"
        />
        <path
          fill="#d48a9b"
          d="M55.05 464.8L55.05 454.7 349.15 454.7 349.15 469.5 55.05 464.8z"
        />
        <path
          d="M138 437.8l131.6 2.7a2 2 0 001.9-1.8 1.27 1.27 0 00-.1-.6l-20.5-55.3-88.6-1.7-26.3 53.6a2.2 2.2 0 001.1 2.9 2.92 2.92 0 00.9.2z"
          transform="translate(-.05)"
          fill="#dfe6f5"
        />
        <path
          d="M138 437.8l131.6 2.7a2 2 0 001.9-1.8 1.27 1.27 0 00-.1-.6l-20.5-55.3-88.6-1.7-26.3 53.6a2.2 2.2 0 001.1 2.9 2.92 2.92 0 00.9.2z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.15000000596046448}
        />
        <path
          d="M137 435.5l132.9 2.8-18.1-54.7a4.51 4.51 0 00-4.2-3.1l-85.4-1.6z"
          transform="translate(-.05)"
          fill="#dfe6f5"
        />
        <path
          d="M148 423.1l15.9-35a4.31 4.31 0 013.9-2.5h39.6a4.23 4.23 0 014.2 4.2v37.9a4.23 4.23 0 01-4.2 4.2h-.2l-55.5-2.8a4.23 4.23 0 01-4-4.4 2.22 2.22 0 01.3-1.6z"
          transform="translate(-.05)"
          fill={theme.text}
        />
        <path
          d="M226 418.6l.7-20a3 3 0 013.1-3h11.7a3.1 3.1 0 013 2.5l3.4 19.9a2.94 2.94 0 01-2.5 3.5h-.5l-15.8.1a2.86 2.86 0 01-3.1-3z"
          transform="translate(-.05)"
          fill="#d1d9ec"
        />
        <path
          d="M71 288.5l44.1-3.7a2.84 2.84 0 013.1 1.8L160 381l-23.3 52.3c.7-1.6 1.3 11.1-4 .1L66.4 295.1c-.9-1.9 2.6-6.3 4.6-6.6z"
          transform="translate(-.05)"
          fill={theme.text}
        />
        <path
          d="M71 288.5l44.1-3.7a2.84 2.84 0 013.1 1.8L160 381l-23.3 52.3c.7-1.6 1.3 11.1-4 .1L66.4 295.1c-.9-1.9 2.6-6.3 4.6-6.6z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.15000000596046448}
        />
        <path
          d="M71 288.5l46.4-5.9a2.84 2.84 0 013.1 1.8l41.7 94.4-25.2 56.7-68.3-142.7a3 3 0 011.4-4z"
          transform="translate(-.05)"
          fill={theme.text}
        />
        <path
          d="M82.6 295.2l33.5-5.2a3.09 3.09 0 013.3 1.8l35.1 85.9a2.44 2.44 0 01-.1 2.2l-16.1 33.6a2.67 2.67 0 01-3.6 1.3 2.74 2.74 0 01-1.3-1.3l-53.1-114a3 3 0 011.4-4 1.61 1.61 0 01.9-.3z"
          transform="translate(-.05)"
          fill={theme.imageHighlight}
        />
        <path
          d="M440.2 488.6s-.7 1.1-1.7 3l-.1.2c-.9 1.6-2 3.7-3.1 6l-2.5.1h-.8c-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-6.2l-4.6.1c-4.8 0-9.6.1-14.4.1h-5.7c-17.6 0-35.2-.4-52.6-1.3l-1.9-.1c3.4-7.5 9.6-19.7 14.5-23.6 3.9-3 31.5-6.3 56.9-8.8l2.7-.3h.1l7.1-.7c9.7-.9 18.6-1.6 24.9-2.1h.6l-3.3-11-4.8-16 1.4-13.4.1-1.1h-.1a9 9 0 01-4-.5l-47.5-1.6h-.9l-18.2-.7c-9.8-.3-16.7-.6-17-.7a1.88 1.88 0 01-.8-.2 7.46 7.46 0 01-1.2-.7 4 4 0 01-1-1.2h-.6l-2.6.2-1.3.1a.6.6 0 01-.1-.4 3.58 3.58 0 00-.4-1.1h-.7l-9-.2h-.2s-23.2 1.8-35.3-2.7c-4.5-1.6-7.4-4.1-7.2-7.7a9.3 9.3 0 01.5-2.4c-3.9-7.3 15.1-20.6 29.7-16.9a26.05 26.05 0 0012.1.5 16.31 16.31 0 006-2.7c.2-.1.3-.3.5-.4a2.51 2.51 0 00-.7-.4 12.13 12.13 0 00-3.2-1.1l3.9-1.2h.1s14-1.3 23.1-1.8h.1c2.7-.1 5-.2 6.4-.2 6 .2 17.7-4.1 18.2-5.4s5.8 0 5.8 0l4.7-1.8c4.7-1.8 7.3-4.3 7.3-6.1s4.2-3.8 4.2-3.8c1.9-3.2 5.6-6.5 9.4-9.5 3.4-2.6 6.8-4.9 9.4-6.5a176.72 176.72 0 014-19.2c1.8-5.9 7.3-10.3 9.2-11.7l.7-.5a61.36 61.36 0 00-2.2-7.3c-.1-.2-.1-.4-.2-.6-.2-.5-.4-.9-.6-1.4l-.3-.6-1.5.3a42.1 42.1 0 01-5 .4 34.18 34.18 0 01-33.1-25v-.1a34.24 34.24 0 01-1.2-9 35.57 35.57 0 011.1-8.6 12.09 12.09 0 01.5-1.8c0-.1 0-.1.1-.2.1-.3.2-.5.3-.8a34.19 34.19 0 01-4.5.4h-1a21.83 21.83 0 01-8.4-1.4 17.38 17.38 0 01-1.9-1 .1.1 0 01-.1-.1 8.34 8.34 0 01-2.1-1.6 11 11 0 004.1-7.1c.3-2.2-.1-4.6 1.2-6.3a10.65 10.65 0 012.3-2c5.3-3.6 9.5-8.6 14.4-12.9s10.6-8 17.1-8.2c8.7-.3 16.3 5.8 24.9 6.9 2.6.4 5.4.2 7.9.9a26.37 26.37 0 018 4.1 20.6 20.6 0 015.7 4.9 16.19 16.19 0 012.3 5.6 62 62 0 012 12.8c.2 4.5 0 9.1.5 13.6a23.37 23.37 0 003.8 10.9h.1l1.2 1.5a25 25 0 01-2.6.7 31.17 31.17 0 01-4.4.9 15 15 0 01-2 .2 6.15 6.15 0 01-1.4-.1l.9.6 2.4 1.6.9.6 1.9 1.2c.4-1.2 1-1.6 1.7-1.5 1.4-1.3 3.4 1.5 3.4 1.5 1.2 2.3 4.4 4.5 7.2 6.2q2.55 1.5 5.1 2.7c37.4 22.3 35 55.6 37.2 58.2s2.3 12.2 2.3 12.2 5.5 32.5 8 35.3.2 3.8 2.3 6.9 1.7 11.5 1.7 11.5 1.5 19.8 6.8 24.1c4.8 3.8 11.2 36.2 12.5 42.9z"
          transform="translate(-.05)"
          fill="url(#b)"
        />
        <path
          d="M221.1 384.4s-5.2 8.2-19.9 4.4-34.1 10.5-28.6 17.5 41.3-2 41.3-2l13.7-2.8-.9-11.4z"
          transform="translate(-.05)"
          fill="#d38884"
        />
        <path
          d="M221.1 384.4s-5.2 8.2-19.9 4.4-34.1 10.5-28.6 17.5 41.3-2 41.3-2l13.7-2.8-.9-11.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M225.9 384l-6.4-.3-3.9 1.1s12.4 1.8 9 18.6l13.4-.8z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M225.9 384l-6.4-.3-3.9 1.1s12.4 1.8 9 18.6l13.4-.8z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M310.2 346.3s-17.5 10-22.4 18.3c0 0-4.1 2-4.1 3.8s-2.6 4.2-7.2 6l-4.6 1.8s-5.2-1.3-5.7 0-11.9 5.5-17.8 5.4-28.9 2-28.9 2a20.44 20.44 0 0111.6 22.7l54.4-2.3 20.6-4.6 12.1-12.1z"
          transform="translate(-.05)"
        />
        <path
          d="M310.2 346.3s-17.5 10-22.4 18.3c0 0-4.1 2-4.1 3.8s-2.6 4.2-7.2 6l-4.6 1.8s-5.2-1.3-5.7 0-11.9 5.5-17.8 5.4-28.9 2-28.9 2a20.44 20.44 0 0111.6 22.7l54.4-2.3 20.6-4.6 12.1-12.1z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M230 418.6l-7.7-.2-9-.2s-42.5 3.3-41.7-10.3 33.5-18.4 38.1-14.5c3.4 3 11.4 5.3 15.1 6.3 1.2.3 1.9.5 1.9.5z"
          transform="translate(-.05)"
          fill="#d38884"
        />
        <path
          d="M230 418.6l-7.7-.2c-3.1-10.5.5-16.4 2.5-18.6 1.2.3 1.9.5 1.9.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M235.2 419.2l-8 .6-3.8.3c-5.2-15.4 3.2-21.4 3.2-21.4h2.5l4.1.5z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M332.1 317.3l-9.5 18s-1.5-18.2-5.7-26.8c-1.1-2.2-2.3-3.8-3.8-4.2-4-1.3 19-26.5 19-26.5.8.2 5.2 3 10.6 6.7 5.9 4 13.1 8.9 17.9 12 9.1 5.7-28.5 20.8-28.5 20.8z"
          transform="translate(-.05)"
          fill="#d38884"
        />
        <path
          d="M320 317.6s-7.6 4.9-9.7 12.1-4.1 20.1-4.1 20.1 3.4 30.9 5.2 32.3 8.6 32.3 8.6 32.3l6.6-4.4-8.7-38.9c0 .1 5.8-49.9 2.1-53.5z"
          transform="translate(-.05)"
        />
        <path
          d="M320 317.6s-7.6 4.9-9.7 12.1-4.1 20.1-4.1 20.1 3.4 30.9 5.2 32.3 8.6 32.3 8.6 32.3l6.6-4.4-8.7-38.9c0 .1 5.8-49.9 2.1-53.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          fill="#a36468"
          d="M353.05 386.5L314.95 386.5 321.15 326.4 353.05 326.4 353.05 386.5z"
        />
        <path
          d="M264.9 507.2h.5l-.9.3zM336.5 479.8l-7.5 2.9-1 .4-26.8 10.3-10.2 3.9-13.9 5.3h-5.7c-17.6 0-35.2-.4-52.6-1.3 3.4-7.4 9.3-19.3 14.1-23.1 3.8-3 30.7-6.2 55.5-8.7 3.1-.3 6.2-.6 9.1-.9l.7-.1c9.9-.9 18.8-1.6 25-2.1l1-.1 7.8-.6.8-.8 1 4.3.8 3.4z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M264.9 507.2h.5l-.9.3zM336.5 479.8l-7.5 2.9-1 .4-26.8 10.3-10.2 3.9-13.9 5.3h-5.7c-17.6 0-35.2-.4-52.6-1.3 3.4-7.4 9.3-19.3 14.1-23.1 3.8-3 30.7-6.2 55.5-8.7 3.1-.3 6.2-.6 9.1-.9l.7-.1c9.9-.9 18.8-1.6 25-2.1l1-.1 7.8-.6.8-.8 1 4.3.8 3.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M264.9 507.2h.5l-.9.3zM297.2 507.2c0 .1-.1.2-.1.3 0-.1.1-.2.1-.3z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          fill={theme.jacketColor}
          d="M335.95 507.5L335.25 507.5 335.15 507.2 335.85 507.2 335.95 507.5z"
        />
        <path
          d="M342.9 469.4l-.6 20.6v1.2l-.3 10.2-7.3.2h-1.1c-10.4.3-20.8.6-31.2.8h-6.2l-4.6.1c-4.8 0-9.6.1-14.4.1h-5.8a216.37 216.37 0 0119.2-10.3c3.3-1.6 6.6-3.2 10-4.8 9-4.2 18.1-8.1 25.5-11.3l1-.4c2.9-1.2 5.5-2.3 7.7-3.2 4.8-2 7.9-3.2 8.1-3.3z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M276.1 384.8c1.9 3.9 3.8 7.9 6.9 10.9.5.5 1.3.9 1.8.4a1.85 1.85 0 00.2-.7 9.54 9.54 0 00-1.8-5.1c-1-1.5-2.2-2.9-3.1-4.5s-1.9-4.7-3.9-5.1c-2.6-.6-.6 2.9-.1 4.1zM342.7 284.4a8.8 8.8 0 01-.5 1.5 33.65 33.65 0 01-25.3 22.5c-1.1-2.2-2.3-3.8-3.8-4.2-4-1.3 19-26.5 19-26.5.8.2 5.2 3.1 10.6 6.7z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M343.9 274.8a33.6 33.6 0 110-.2z"
          transform="translate(-.05)"
          fill="#d38884"
        />
        <path
          d="M323.1 324.8s-7 8.5-5.9 14.1h8.5l6.2-7z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M348 288.9l-26.7 36.7s6.9 9.8 10.1 10.3 21.9-43.4 21.9-43.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M348.4 288.2L321.7 325s6.9 9.8 10.1 10.3 21.9-43.4 21.9-43.4z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M318.2 335.2s-1.3 20.6-2.6 24.7 0 41.7 0 41.7l12.3-5.1-2.1-57.7z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M335.85 507.2L335.95 507.5 335.25 507.5 335.15 507.2 335.85 507.2z"
        />
        <path
          d="M436.4 489.5a10.39 10.39 0 01-.6 1 23.94 23.94 0 00-1.3 2.4l-.1.1c-.7 1.4-1.6 3-2.5 4.9-30 1.1-60 2.5-89.9 3.5l-7.3.2h-1.1l-3.1-10.6v-.1l-.3-1.1-2-6.7-2-6.8-2.1-7.2-.8-2.6-.2-.7-3.3-11.1-4.4-15.1 1.4-14.4.1-1.1 1.3-12.9.2-3.8.1-2v-.6l.2-4.6.7-13.8.3-7.1.1-1.1.7-14.2 1.9-5.8 1-2.9 2.2-6.7.5-1.7c.7-2.5 2.1-7.5 3.4-12.2l.1-.4.1-.3.9-3.4 1.2-4.4c.4-1.7.7-2.9.8-3.3.1-.7 2-3.9 4.5-8 5-8.3 12.5-20.4 13.4-24.5v-.1c.1-.2.1-.5.2-.7.4-1.2 1-1.5 1.6-1.5a1.91 1.91 0 01.8.3 7.52 7.52 0 011.6 1.5c1.2 2.3 4.3 4.5 7.1 6.2l.5.3.3.2a45.09 45.09 0 004.2 2.1c36.6 22.1 34.3 55.1 36.4 57.7s2.3 12.1 2.3 12.1 5.4 32.2 7.8 35 .2 3.8 2.3 6.9 1.6 11.3 1.6 11.3 1.5 19.6 6.7 23.8 12.5 44 12.5 44z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M437.4 489.2l-.4.8c-.4.6-.9 1.6-1.6 2.8l-.1.1a46.46 46.46 0 00-2.5 5h-.8c-30 1.1-60 2.5-89.9 3.5l-7.3.2-3.1-10.6v-.1l-.3-1.1-2.1-7-2-6.8-2-6.8-.8-2.7-3.4-11.7-4.5-15.4 1.3-12.5.2-1.7 1.4-14.2.5-11.1.6-13.4.2-3.5.2-4.1.1-1.7.6-13.4 1.9-5.8.8-2.5 1.9-5.8.4-1.2s1.9-6.6 3.7-13.1c.1-.2.1-.5.2-.7.2-.6.3-1.1.5-1.7.2-.6.3-1.1.5-1.7.5-1.8 1-3.5 1.3-4.9.5-1.8.8-3.2.9-3.6.1-.7 2-3.9 4.6-8.1 4.7-7.8 11.6-19 13.1-23.6.1-.2.1-.5.2-.7a4 4 0 01.9-2c1.3-1.3 3.3 1.5 3.3 1.5 1.2 2.3 4.3 4.5 7.1 6.2a34 34 0 005 2.6c36.6 22.1 34.3 55.1 36.4 57.7s2.3 12.1 2.3 12.1 5.4 32.2 7.8 35 .2 3.8 2.3 6.9 1.6 11.4 1.6 11.4 1.5 19.6 6.7 23.9 12.3 43.5 12.3 43.5z"
          transform="translate(-.05)"
        />
        <path
          d="M362.7 296.6c-3.6 5.2-9.4 14.4-11 21 0 0-5.7 5.9-7.9 5.6s2 4.4 2 4.4l-22.5 31.1 3.2-9.6s6.7-23.5 7-25.6 16.6-26.4 17.9-32.5c1-4.9 4.2-.5 4.2-.5 1.2 2.2 4.4 4.5 7.1 6.1z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M362.7 296c-3.6 5.2-9.4 14.4-11 21 0 0-5.7 5.9-7.9 5.6s2 4.4 2 4.4l-22.4 31 3.2-9.6s6.7-23.5 7-25.7 16.6-26.4 17.9-32.5c1-4.9 4.2-.5 4.2-.5 1.1 2.3 4.3 4.6 7 6.3z"
          transform="translate(-.05)"
        />
        <path
          d="M392.9 360.5c.2 7.1-10.3 16.9-10.8 17.5s-32.5 27-32.5 27l-23 17.6a20.17 20.17 0 01-9 4.2l1.6-15.8 1.5-32c3.6-4 7.1-8.2 7.1-9.5.2-2.8 6-5.7 6-5.7s4.1-3.4 3.4-5.4 2.2-11.4 2.2-11.4c1.5-26.6 28.9-29.3 28.9-29.3s13.2 5.2 22.5 10.8 2 24.9 2.1 32zM235.2 419.2l-8 .6c-3.4-5.8 1.3-21.2 1.3-21.2h.6l4.1.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M368.4 316.1s-27.5 2.6-28.9 29.3c0 0-2.8 9.3-2.1 11.3s-3.4 5.4-3.4 5.4-5.9 2.9-6 5.7-15 17.9-15 17.9-6.2 7.1-20.6 7.8-21.1 5.1-21.1 5.1-7-4.9-12.1-3.4-29.9 3.4-29.9 3.4-6.6 21.8 1.6 23.2c1 .2 81.9 2.9 81.9 2.9s5.5 2.6 13.9-3.8 23-17.7 23-17.7 32-26.5 32.5-27 11-10.3 10.8-17.5 7.4-26.4-2-32-22.6-10.6-22.6-10.6z"
          transform="translate(-.05)"
        />
        <path
          d="M343.9 274.8a36.42 36.42 0 01-1.6 10.4 6.57 6.57 0 01-1.2-1.7c-1.6-2.4-3.1-4.8-4.7-7.2a17.26 17.26 0 00-4.8-5.6c-2-1.4-4.8-2-7-.7-1.9 1.1-2.8 3.4-3 5.6a48.52 48.52 0 00.2 6.6 3.48 3.48 0 01-.6 2.4 4 4 0 01-2.6 1l-3 .4a2.12 2.12 0 01-2.7-1.3v-.1c-2.5-4.5-4.2-10.1-8.9-12.3-2.9-1.3-6.7-1.3-8.5-3.8-1.3-1.8-1.1-4.1-.7-6.3a43.45 43.45 0 011.8-7.1c.5-1.6 1.7-4.9-.9-5.2-1.8-.2-4.2 1.7-5.1 3s-1.1 3.1-1.8 4.7a11 11 0 01-6.1 5.7 16.31 16.31 0 01-4.2 1.1 33.48 33.48 0 0165.4 10.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M290.3 252c-.9 1.4-1.1 3.1-1.8 4.6a11 11 0 01-6.1 5.7 24.41 24.41 0 01-8.4 1.5c-4.7.1-9.9-.6-12.9-4.1a10.67 10.67 0 004-7c.3-2.1-.1-4.5 1.2-6.3a7.1 7.1 0 012.3-1.9c5.2-3.6 9.3-8.5 14.1-12.8s10.4-7.9 16.8-8.1c8.5-.3 16 5.7 24.4 6.9 2.6.4 5.2.2 7.8.9a26.76 26.76 0 017.9 4 20.07 20.07 0 015.6 4.8 16.52 16.52 0 012.3 5.5 60 60 0 012 12.7c.2 4.5 0 9 .5 13.5s1.9 9 5 12.3a51.71 51.71 0 01-6.8 1.6 7.84 7.84 0 01-4.3-.3 7.29 7.29 0 01-2.6-2.9l-4.7-7.2a17.26 17.26 0 00-4.8-5.6c-2-1.4-4.8-2-7-.7-1.9 1.1-2.8 3.4-3 5.6a48.52 48.52 0 00.2 6.6 3.48 3.48 0 01-.6 2.4 4 4 0 01-2.6 1l-3 .4a2.12 2.12 0 01-2.7-1.3v-.1c-2.5-4.5-4.2-10.1-8.9-12.3-2.9-1.3-6.7-1.3-8.5-3.8-1.3-1.8-1.1-4.1-.7-6.3a43.45 43.45 0 011.8-7.1c.5-1.6 1.7-4.9-.9-5.3-2.2-.3-4.7 1.6-5.6 3.1z"
          transform="translate(-.05)"
        />
        <path
          d="M366.5 331c2.5-.4 5.2-.6 7.6.4-6.2-2.5-16.2-1.6-21.8 1.9.4 1.2 12.2-2 14.2-2.3zM369.4 339.2c6.1.4 12.5 1.3 18.3-.7-4.9-1.7-10.3-.6-15.4-1.1-4.1-.4-8.3-1.8-12.3-.8-1.7.4-7.8 3.3-7.4 5.3a34.85 34.85 0 0116.8-2.7zM353.1 352.7a9.68 9.68 0 013.8.4 55.41 55.41 0 0014.1 1.5c3.6 0 7.5-.5 10.2-3zM333.3 384a28.31 28.31 0 0013.8 2.5 54.43 54.43 0 0013.8-2.7c2-.6 4.2-1.3 5.4-3.1zM377.6 388.4a73.52 73.52 0 0030.5 9.5c-5.4-2.2-10.9-4.2-16.4-6.2a113 113 0 00-17.3-4.6 7 7 0 013.2 1.3zM392.7 382.6a27.26 27.26 0 005.7.3 3.18 3.18 0 002.8-1c-4.3.2-8.5-.9-12.7-1.9-1.2-.3-3.3-.9-4.3-.2 1.8 1.4 6.1 2.4 8.5 2.8zM418.5 472c2.3 3.9 4.5 7.8 7.6 11a52.69 52.69 0 005.7 4.9c-3.7-9.5-7.5-19-13.4-27.3-1.5-2.1-3.7-5.1-6.5-5.4-.8 2.3 1.2 6.4 2.1 8.6 1.4 2.8 2.9 5.5 4.5 8.2zM309.2 401.2c-.2 1.6-.3 3.4.6 4.7a3.63 3.63 0 001.9 1.3c-.5-.1-1-4.8-1.1-5.5-.2-1.3 0-3.8-.9-4.7a30.06 30.06 0 00-.5 4.2zM314.4 399.4a11.11 11.11 0 005 6.8c-1.8-2.2-2.3-5-3.8-7.4-.5-.8-1.1-1.8-2-2a12.94 12.94 0 00.8 2.6zM310 370.6a12.74 12.74 0 01-9.9 1.3c-.8-.2-2.5-1-2.1-2.1s2.5-.3 3.3-.2l4.4.5c.7 0 3.6.9 4.3.5zM295.3 377.7c2-.3 3.9 1.2 5.8 1.9a18.5 18.5 0 006.6.9c1.1 0 2.4-.1 3.1-1-5.3-1.2-10.1-2.5-15.5-1.8z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          fill="#a36468"
          d="M319.95 317.6L320.25 317.6 322.75 326.4 319.95 329.4 319.95 317.6z"
        />
        <g opacity={0.10000000149011612}>
          <path
            d="M265.8 247.7a21.18 21.18 0 00-.5 4.4c.1-.5.2-.9.3-1.4.1-1 .1-2 .2-3zM295.6 248.9a1.86 1.86 0 011.7 1.9v.1c.5-1.7.7-3.7-1.3-4-1.8-.2-4.2 1.7-5.1 3s-1.1 3.1-1.8 4.7a11 11 0 01-6.1 5.7 24.41 24.41 0 01-8.4 1.5c-4.2.1-8.9-.5-12-3.3a12 12 0 01-1.2 1.1c3 3.6 8.2 4.3 12.9 4.1a24 24 0 008.4-1.5 11 11 0 006.1-5.7c.6-1.5.8-3.3 1.8-4.6s3.2-3.3 5-3zM348.4 283.7a7.84 7.84 0 01-4.3-.3 7.29 7.29 0 01-2.6-2.9c-1.6-2.4-3.1-4.8-4.7-7.2a17.26 17.26 0 00-4.8-5.6c-2-1.4-4.9-2-7-.7-1.9 1.1-2.8 3.4-3 5.6v.3a6.37 6.37 0 012.7-3.9c2.1-1.3 5-.7 7 .7a23.37 23.37 0 014.8 5.6c1.6 2.4 3.1 4.8 4.7 7.2a8 8 0 002.6 2.9 6.39 6.39 0 004.3.3 39.53 39.53 0 006.8-1.6l-1.2-1.5a31.16 31.16 0 01-5.3 1.1zM321.6 281.6a4 4 0 01-2.6 1l-3 .4a2.12 2.12 0 01-2.7-1.3v-.1c-2.5-4.5-4.2-10.1-8.9-12.3-2.9-1.3-6.7-1.3-8.5-3.8a7.31 7.31 0 01-.9-5.2 2.92 2.92 0 01-.2.9c-.4 2.1-.5 4.5.7 6.3 1.9 2.6 5.6 2.5 8.5 3.8 4.7 2.2 6.4 7.8 8.9 12.3a3 3 0 001.1 1.4 2.92 2.92 0 001.6.1l3-.4a4 4 0 002.6-1 3.35 3.35 0 00.6-2.4c0 .1-.1.2-.2.3z"
            transform="translate(-.05)"
          />
        </g>
        <path
          d="M735.4 517.4l-6.4-.9v-94.6l1.3.4 4 1.2v13.3l.1 8.5v11.5l.5 42.6v1.1l.2 15v.2z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          d="M739 517.9l-3.6-.5v-1.9l-.2-15v-1.1l-.5-42.6v-11.6l-.1-8.5v-13.3h3.8v12.2l.1 9.1v9.7l.4 44.7v1.2l.1 14.9v2.7z"
          transform="translate(-.05)"
          fill="#d3dae1"
        />
        <path
          d="M1128 410.1v81.7c-1.9 1.3-3.8 2.6-5.8 3.9l-.1-68v-7.2z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          d="M1132.2 409v79.7c-1.4 1.1-2.8 2.1-4.2 3.2v-81.7z"
          transform="translate(-.05)"
          fill="#d3dae1"
        />
        <path
          d="M1039.3 524.7c-2.5.5-4.9 1-7.4 1.4l-.1-73.9V449l7.1-3v6.8z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          d="M1044 443.7v80c-1.6.3-3.1.7-4.7 1l-.3-71.9V446l.5-.2z"
          transform="translate(-.05)"
          fill="#d3dae1"
        />
        <path
          d="M620.2 502.6l-6.7-.7-.8-83.3v-4h6.5v4.6z"
          transform="translate(-.05)"
          fill="#eaecf0"
        />
        <path
          d="M625.1 503.1l-5-.5-1-83.5v-4.6h5v5z"
          transform="translate(-.05)"
          fill="#d3dae1"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M1039.35 445.8L1043.95 443.7 1043.95 453.8 1039.55 455.3 1039.35 445.8z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M1132.15 409L1132.15 424.4 1127.95 425.8 1122.05 427.8 1122.05 420.5 1127.95 410.1 1132.15 409z"
        />
        <path
          fill="#d48a9b"
          d="M1132.15 379.3L1132.15 422 1039.55 452.9 1038.95 407.2 1132.15 379.3z"
        />
        <path
          fill="#efc6cd"
          d="M611.45 376.3L733.15 353.1 1132.15 379.3 1038.95 407.2 611.45 376.3z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M624.15 414.6L624.25 419.6 619.15 419.1 612.65 418.6 612.65 414.6 624.15 414.6z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M738.25 429.4L734.35 429 728.95 428.6 728.95 421.9 734.35 423.5 738.15 423.5 738.25 429.4z"
        />
        <path
          fill="#d48a9b"
          d="M611.45 376.3L611.45 416.1 1039.55 452.9 1038.95 407.2 611.45 376.3z"
        />
        <path
          fill="#d48a9b"
          d="M950.85 423.6L894.95 423.6 894.95 403.3 950.85 407.3 950.85 423.6z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M950.85 423.6L894.95 423.6 894.95 403.3 950.85 407.3 950.85 423.6z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M819.85 398.9L819.85 430.9 1034.45 447.3 1034.45 413.1 950.75 408.4 942.45 415.8 908.25 413.4 896.15 404.5 819.85 398.9z"
        />
        <path
          fill="#fff"
          d="M818.65 397.7L818.65 429.7 1033.25 446.1 1033.25 411.9 949.55 407.2 941.25 414.6 907.15 412.2 894.95 403.3 818.65 397.7z"
        />
        <path
          fill="#d48a9b"
          d="M686.25 389.1L736.95 392.6 736.45 408.8 703.25 408.8 681.05 400 686.25 389.1z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M686.25 389.1L736.95 392.6 736.45 408.8 703.25 408.8 681.05 400 686.25 389.1z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M618.55 384.6L618.55 413.4 813.25 428.9 813.25 398.3 738.15 393.8 730.15 399.8 699.85 398 687.45 390.3 618.55 384.6z"
        />
        <path
          fill="#fff"
          d="M617.35 383.4L617.35 412.2 812.15 427.7 812.15 397.1 736.95 392.6 728.95 398.6 698.65 396.8 686.25 389.1 617.35 383.4z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M1034.45 383.5L1061.75 385.3 1016.55 398.9 993.55 397.2 1034.45 383.5z"
        />
        <path
          fill="#fff"
          d="M1034.45 382.4L1061.75 384.1 1016.55 397.7 993.55 396 1034.45 382.4z"
        />
        <path
          d="M1031.3 385.4c1.1-.5 2.2.4 3.4.6.7.1 1.3 0 2 .1 1.3.2 2.7 1.1 3.9.6zM1029.9 386.2c1.1-.5 2.2.4 3.4.6.7.1 1.3 0 2 .1 1.3.2 2.7 1.1 3.9.6zM1026.6 387.9c1.1-.5 2.2.4 3.4.6.7.1 1.3 0 2 .1 1.3.2 2.7 1.1 3.9.6z"
          transform="translate(-.05)"
          fill="#d3dae1"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M850.25 368.5L911.15 372.5 898.25 391.2 831.25 384 850.25 368.5z"
        />
        <path
          fill="#3a3768"
          d="M849.15 367.4L909.95 371.3 897.05 390 830.05 382.8 849.15 367.4z"
        />
        <path
          fill="#d5e1f4"
          d="M851.75 368.7L904.85 372 893.55 387.2 835.25 381.3 851.75 368.7z"
        />
        <path
          d="M816.2 521v.8a2.2 2.2 0 01-.1.8 15 15 0 01-1.5 5.1c-25.2-2.8-50.4-6.2-75.6-9.7l-3.6-.5-6.4-.9-5.4-.8a115.27 115.27 0 01-17.6-1.7 81.23 81.23 0 01-10.9-2.3c-16-2.2-32.1-4.3-48.1-6.2l-2.1-.3c.4-1.7.7-2.7.7-2.7s3.4-13.5 6.3-28.6l1.8-9.9c.4-2.7.8-5.3 1.1-7.8.2-1.4.3-2.8.5-4.1.1-.7.1-1.3.2-2s.1-1.4.2-2.1a12.75 12.75 0 00.1-1.9v-5.1a119.24 119.24 0 00-3.4-21.4l-.9-3.6c-.1-.4-.2-.8-.3-1.1-3.2-12.5-7-22.7-7-22.7v-2.4c.1-1 .3-2.1.5-3.1a4.87 4.87 0 01.4-1.1 6.75 6.75 0 014.5-4.2c2.8-.7 7.1 0 13.6 3.8a16.1 16.1 0 013 2.1 17.41 17.41 0 011.4 1.2c7.4 6.9 11.3 18.3 13.4 28.6a4.25 4.25 0 01.2 1.1c.3 1.3.5 2.5.7 3.8.3 2.2.6 4.2.8 6.2a7.72 7.72 0 00.2 1.5 7.57 7.57 0 01.1 1.5q.15 2.4.3 4.2a51.27 51.27 0 01.1 5.2v1.5a10.4 10.4 0 01-.2 1.5q-.15 1.35-.3 3c-.1.8-.2 1.8-.3 2.7-.2 2-.5 4.3-.7 6.8-.1.5-.1.9-.2 1.4-.2 2.1-.5 4.3-.7 6.5l-.9 7.5c-.1.5-.1 1.1-.2 1.6-.7 6-1.5 11.5-2.1 14.8a7.72 7.72 0 00-.2 1.5v1.9c.5 8.5 9.7 10 9.7 10l41.9-.8 6.2-.1 3.6-.1 32.7-.7 3-.1 16.3-.3a12.42 12.42 0 013.3.4 49.86 49.86 0 0114.2 6.2 18.93 18.93 0 013.7 3.2c.1 0 .1.1.1.2a17.13 17.13 0 013.9 9.4v.7a4.29 4.29 0 010 1.6z"
          transform="translate(-.05)"
          fill="#3a3768"
        />
        <path
          d="M816.2 521v.8a2.2 2.2 0 01-.1.8 15 15 0 01-1.5 5.1c-25.2-2.8-50.4-6.2-75.6-9.7l-3.6-.5-6.4-.9-5.4-.8a115.27 115.27 0 01-17.6-1.7 81.23 81.23 0 01-10.9-2.3c-16-2.2-32.1-4.3-48.1-6.2l-2.1-.3c.4-1.8.7-2.8.7-2.8s2.8-11 5.5-24.3a23.25 23.25 0 00.5-2.8l.3-1.4 1.8-9.9c.4-2.7.8-5.3 1.1-7.8.2-1.4.3-2.8.5-4.1.1-.7.1-1.3.2-2s.1-1.4.2-2.1a12.75 12.75 0 00.1-1.9v-5.1a119.24 119.24 0 00-3.4-21.4l-.9-3.6c-.1-.4-.2-.8-.3-1.1-3.2-12.5-7-22.8-7-22.8v-2.3a16.68 16.68 0 01.5-3.1 7.6 7.6 0 01.4-1.1 6.39 6.39 0 014.7-4.3c2.8-.7 7.1.2 13.4 3.9a21.84 21.84 0 013.1 2.2c.5.4.9.8 1.4 1.2 7.3 6.9 11.3 18.3 13.3 28.6a5.16 5.16 0 01.2 1.1c.3 1.3.5 2.5.7 3.8.3 2.2.6 4.2.8 6.2a7.72 7.72 0 00.2 1.5 7.57 7.57 0 01.1 1.5q.15 2.4.3 4.2a51.27 51.27 0 01.1 5.2v1.5a10.4 10.4 0 01-.2 1.5q-.15 1.35-.3 3-.15 1.2-.3 2.7c-.2 2-.5 4.3-.7 6.8-.1.5-.1.9-.2 1.4-.2 2.1-.5 4.3-.7 6.5l-.9 7.5c-.1.5-.1 1.1-.2 1.6-.7 6-1.5 11.4-2.1 14.7a8.75 8.75 0 00-.2 1.6v1.9c.6 8.4 9.7 9.8 9.7 9.8l41.9-.8 6.2-.1 3.6-.1 32.7-.6 3.1-.1 16.2-.3a12.42 12.42 0 013.3.4 49.25 49.25 0 0114.3 6.2 14.61 14.61 0 013.7 3.3c.1 0 .1.1.1.2a17.13 17.13 0 013.9 9.4v.7a8.64 8.64 0 01-.1 1.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M816.3 527.8l-1.7-.2c-25.2-2.8-50.4-6.2-75.6-9.7l-3.6-.5-6.4-.9-5.4-.8A115.27 115.27 0 01706 514a81.23 81.23 0 01-10.9-2.3c-16-2.2-32.1-4.3-48.1-6.2.3-1.4.6-2.8 1-4.2 0 0 9.5-37.4 10.1-57.3.2-7.1-1.2-15.9-3.1-24.3l-.9-3.6-.3-1.1c-3.4-13.2-7.4-24.2-7.4-24.2a18.8 18.8 0 01.2-4.1c.1-.4.1-.7.2-1.1a8 8 0 012.6-4.3c.1-.1.1-.1.2-.1 2.6-2 7.3-2.1 15.8 2.8a23.46 23.46 0 014.7 3.6l1.2 1.2c6.8 7.3 10.3 18.5 12.2 28.5l.2 1.1c.2 1.3.4 2.5.6 3.7v.1q.3 2.4.6 4.5a108.62 108.62 0 01.7 12.8s-.4 4-1 9.6c-.2 2.2-.5 4.7-.8 7.4v.4l-.2 1.4c-.5 4.6-1.1 9.5-1.6 14.1-.1.6-.1 1.1-.2 1.7-.6 5.1-1.3 9.7-1.8 12.7-2.1 11.6 9.5 13.4 9.5 13.4l39.5-.8 6.2-.1 3.6-.1h2l31.4-.6h3l18-.4a12.42 12.42 0 013.3.4 51.86 51.86 0 0114.3 6.1 18.66 18.66 0 013.4 2.9l.2.2a17.36 17.36 0 011.9 20z"
          transform="translate(-.05)"
          fill="#3a3768"
        />
        <path
          fill={theme.text}
          d="M957.65 347L969.85 373.3 967.75 373.3 953.45 347.4 957.65 347z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M957.65 347L969.85 373.3 967.75 373.3 953.45 347.4 957.65 347z"
        />
        <path
          fill={theme.text}
          d="M957.65 373.3L969.85 373.3 969.85 376 957.65 376.3 957.65 373.3z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M957.65 373.3L969.85 373.3 969.85 376 957.65 376.3 957.65 373.3z"
        />
        <path
          d="M862.5 250.6v91.5a6.74 6.74 0 006.8 6.8h152.5a6.79 6.79 0 006.8-6.7v-.1l-1.7-91.6a6.77 6.77 0 00-6.8-6.6H869.3a6.79 6.79 0 00-6.8 6.7z"
          transform="translate(-.05)"
          fill={theme.text}
        />
        <path
          d="M862.5 250.6v91.5a6.74 6.74 0 006.8 6.8h152.5a6.79 6.79 0 006.8-6.7v-.1l-1.7-91.6a6.77 6.77 0 00-6.8-6.6H869.3a6.79 6.79 0 00-6.8 6.7z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M857 250.6v91.5a6.74 6.74 0 006.8 6.8h152.5a6.7 6.7 0 006.7-6.7v-.1l-1.7-91.6a6.74 6.74 0 00-6.7-6.6H863.9a6.74 6.74 0 00-6.9 6.7z"
          transform="translate(-.05)"
          fill={theme.text}
        />
        <path
          d="M863 256.4v80.5a6.74 6.74 0 006.8 6.8H1011a6.81 6.81 0 006.8-6.8v-80.6a6.72 6.72 0 00-6.8-6.7H869.8a6.81 6.81 0 00-6.8 6.8z"
          transform="translate(-.05)"
          fill={theme.imageHighlight}
        />
        <path
          fill={theme.text}
          d="M924.05 347.4L937.45 373.3 967.75 373.3 952.65 343.7 924.05 347.4z"
        />
        <path
          fill={theme.text}
          d="M913.45 373.3L911.15 376 957.65 376 957.65 373.3 913.45 373.3z"
        />
        <path
          d="M717.6 278.4c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm173.7 93.2l-.8-.1 1-.2a.37.37 0 00.3-.1c1.1-.2 2.2-.5 3.3-.8l1.1-.3h.2c9.3-2.8-1.5-5.3-15.4-7.2-14.9-2-33.2-3.3-33.2-3.3l-5.7.8h-.1c-7 .9-18 2.4-19.8 3-2.1.7-20.3 1.6-26.6 1.9a2.19 2.19 0 00-.9-1l-18.7-.9v2.6l-.1-.1a26.33 26.33 0 00-2.5-10l-.1-.3c-4.8-9.1-5.8-11.4-5.8-11.4 0-.2-.1-.3-.1-.5-1.6-5.6-7.6-15.4-17.7-29.4l-.3-.5-1.3-6.2-.2-1.1h-6.4a78.86 78.86 0 014.4-15.8 10.37 10.37 0 00.4-1l.1-.2a4.67 4.67 0 01.5-1h1.1a30.41 30.41 0 0029.2-28.3v-.1c0-.6.1-1.2.1-1.9a30.34 30.34 0 00-4-15c-.1-.1-.2-.3-.3-.4l-.2-.3-.4-.6c2.3-.5 5 .5 7-.8a5.1 5.1 0 001.7-2.1 10.6 10.6 0 001-3v-.3a14.92 14.92 0 00.2-2.1 12.34 12.34 0 00-.7-4.2 11.67 11.67 0 00-6.4-6.5c-1.5-.5-3.1-.9-4.7-1.3-6.4-1.7-11.8-5.9-18-8.3a34.44 34.44 0 00-13.5-2.1 20.1 20.1 0 00-8 2 29 29 0 00-5.3 3.9c-4.5 3.5-9.5 6.5-13.4 10.7-.7.8-1.3 1.6-1.9 2.4-.3.5-.7 1-1 1.5a2.8 2.8 0 00-2.4-1h-.5c-.4 0-.8.1-1.2.1-1 .2-8.5 2.1-8.5 3.2a33.27 33.27 0 00-8.6 5.3c-6 5.5-7.3 14.2-8.1 22.2a201.65 201.65 0 00-1 28c.1 3.4.4 6.8.3 10.2a79.5 79.5 0 01-1.8 11.9c-.9 4.1-1.8 8.1-2.8 12.2-.5 2-1.3 4.2-3.2 4.9l.7.1c-.2.1-.5.3-.7.4l2.5.3h.6a5.9 5.9 0 001.4-.2 4.94 4.94 0 001.8-.8 1.42 1.42 0 00.2-.6 3.47 3.47 0 001.2-1.9 13 13 0 01-.2 3.4c0 .2-.1.3-.1.5a13.62 13.62 0 01-3.4 6.5l1-.8a10.59 10.59 0 01-1 1.2c1.4-1.1 2.9-2.2 4.3-3.3.1-.1.2-.1.3-.2l2.5-1.9v2.4c-.2 6.9-.5 23.8 1.1 27.9.1.2.2.5.3.7 1.8 4.6 2.6 6.6 2.3 9-.2 1.7 1.1 6.5 1.8 10.3a11.94 11.94 0 01.3 4.6 6.66 6.66 0 00.2 2.8c.1.4.2.9.3 1.4 0 .2.1.3.1.5.9 3.6 2.2 8.1.8 9.9a7.5 7.5 0 00-1 2c-1.1 3-1.3 7.1-2.6 8.8-1.5 1.9-1 5.4-.9 5.8s-.1.4-.2 1c-.2.8-.4 2.1-.8 3.6v.1a57.2 57.2 0 01-1.7 5.9c-.5 1.4-1 2.3-1.6 2.5-2 .7-3 10.1-3 10.1s-4.6 7.4-3.7 9.3a7.46 7.46 0 00.7 1.2l-.4.7c-2.5 3.9-6 11.1-2.6 14.9a17.71 17.71 0 004.1 3.1c-.2.4-.4.8-.6 1.3-3.8 8.9-9.6 29.4 12.8 38.1a53.9 53.9 0 006.8 2.2 81.23 81.23 0 0010.9 2.3 121.92 121.92 0 0016 1.4c2.4.1 4.7.1 7 .1s4.3-.1 6.4-.2c1.2 0 2.4-.1 3.6-.2a176.1 176.1 0 0020.5-2.3l32-5.7s13.4.5 18.4 3.3l.2.1 2.2-1.4q.9-.6 2.1-1.5c5.1-3.7 13.5-11 19.1-21.2l.1-.2 1.1-.1h.3l.8-.1 1.6-.2h.3l7.9-1.2s.2 4.5.3 9.7c.1 1.6.1 3.2.2 4.8.2 5.5.4 10.5.4 10.6s4.1 11 8.7 21.9l3.6.3c9.5.8 19 1.4 28.5 1.9l3.5.2 2.2.1c-1.6-9.7-2.9-18.9-2.9-18.9l-5.9-27.7s-.6-5.7-5.1-31.2c-3.6-20.6-24.8-18.8-32.7-17.4-.8.2-1.5.3-2 .4v-1.5s-15.2 1.3-29 1.9l-3.3.1c-3.2.1-6.2.2-8.9.2-2.3 0-4.7-.1-7-.3-10.6-1.2-22.8 2.4-22.8 2.4s-15.5 2.5-17.6 1.6a11.63 11.63 0 00-1.8-.4h-1a1.68 1.68 0 001-1.8c-.6-2.6-.9-6.1.9-8.5.8-1.1 2-2.8 3.1-4.3l2.7-3.7v-.3l.1-1.1.7-9.7 1.6-9 .1-.6.1-.8.1-.6.3.1c4.4 1.5 9.5 2.6 13 1.4h.1a6.89 6.89 0 00.8-.3h.2v.7l.1 1.2 16.7-.9h.3s.7-3.2 1.3-7.7a4.25 4.25 0 01.2-1.1 6.8 6.8 0 00.2-1.5c0-.2.1-.5.1-.7h1c7.7-.3 18.5-.9 22.9-2.5a7.14 7.14 0 001.5-.8c1.9-1.6 8.6-3.9 15.2-5.9l2.6-.8c1.9-.6 3.8-1.1 5.4-1.5l6.5-1.7s26 2.4 45.4-3.2l.3-.1c7-2.2 2.4-4.1-6.3-5.8zm-184.4-130c0 .3.1.6.1.9a.6.6 0 00.1.4.6.6 0 00.1.4c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3l.2.1h.3l-.1.2a.1.1 0 01-.1.1l-.1.1a64.46 64.46 0 01-4.2 6.4 9.54 9.54 0 00-3.5 1.4l-.6.4-.2.2a47.68 47.68 0 00-1.3-5.1 118.63 118.63 0 01-3.9-27.7v-1.9c0-2.4.1-4.8.2-7.3a7.22 7.22 0 01.8-3.2 3.1 3.1 0 011.7-.7zm10.7 36.8c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3zm0 0c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6l-.3.1-.3.1-.3.1-.2.1c.1.3.1.6.2.9.5 1.4 1.1 2.7 1.7 4 4.1 9.1 4.1 19.5 7.5 29a2.38 2.38 0 00.6 1.1 2.19 2.19 0 00.5.3c.1-.2.1-.2.1-.3z"
          transform="translate(-.05)"
          fill="url(#c)"
        />
        <path
          d="M751 283.7a22 22 0 00-3.8 5.9 3 3 0 00-.4 1c-4.4 10-5.9 24.1-5.9 24.1s-2.7-1.2-6.6-3.1c-7.2-3.6-18.4-9.5-22.9-14.3-2-2.1-2.7-4-1.1-5.4a10 10 0 001.1-1 44.67 44.67 0 003.5-4.1c1.4-2 2.9-4.2 4.2-6.5.8-1.3 1.5-2.7 2.2-4l.3-.5c3-5.7 5.2-10.5 5.2-10.5s1 .3 2.6.9c7.4 2.6 28 10.7 21.6 17.5zM887.9 515.4s1.2 9.1 2.8 18.6l-3.5-.2c-9.5-.5-19-1.1-28.5-1.9-5.4-12.5-11-27.4-11-27.6s-.2-5.1-.4-10.6c-.1-1.9-.1-3.9-.2-5.8-.1-2.8-.2-5.4-.2-6.9a11.48 11.48 0 00-.1-1.7s-5.1.9-9.8 1.5l-2 .3c-1.1.1-2 .2-2.8.3a8.1 8.1 0 01-2.2 0c-1.6-.6 1.7-16 1.7-16l8.2-19.8 2.3-5.5 1-.3c.5-.1 1.2-.3 1.9-.4 7.8-1.4 28.6-3.3 32.1 17.3 4.4 25.4 5 31.1 5 31.1zM895.8 556z"
          transform="translate(-.05)"
          fill="#efb7b9"
        />
        <path
          d="M887.9 515.4s1.2 9.1 2.8 18.6l-3.5-.2c-9.5-.5-19-1.1-28.5-1.9-5.4-12.5-11-27.4-11-27.6s-.2-5.1-.4-10.6c-.1-1.9-.1-3.9-.2-5.8-.1-2.8-.2-5.4-.2-6.9a11.48 11.48 0 00-.1-1.7s-5.1.9-9.8 1.5l-2 .3c-1.1.1-2 .2-2.8.3a8.1 8.1 0 01-2.2 0c-1.6-.6 1.7-16 1.7-16l8.2-19.8 2.3-5.5 1-.3c.5-.1 1.2-.3 1.9-.4 7.8-1.4 28.6-3.3 32.1 17.3 4.4 25.4 5 31.1 5 31.1zM895.8 556z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.05000000074505806}
        />
        <path
          d="M887.1 533.8c-9.5-.5-19-1.1-28.5-1.9l-3.6-.3-1.6-.1c-4.5-10.8-8.5-21.4-8.5-21.6s-.2-5.1-.4-10.6c-.2-6.8-.5-14.4-.5-14.4l-.7.1h-.6l-1.6.3-.9.1c-1.6.3-3.5.5-5.4.8l-.4.1-1.1.1-1 .1a18 18 0 01-2.2.2l-.8.1a8.1 8.1 0 01-2.2 0c-1.6-.6 1.7-16 1.7-16l10.4-25.3.4-.1c.5-.1 1.7-.4 3.3-.7.6-.1 1.2-.2 1.9-.3 9.1-1.2 26.3-.8 29.5 17.7 4.4 25.4 5 31.1 5 31.1l5.8 27.6c.2.2.9 5.9 2 13z"
          transform="translate(-.05)"
          fill="#efb7b9"
        />
        <path
          d="M844.6 499.3c-.2-6.8-.5-14.4-.5-14.4s-10 1.8-14.7 2.1l.9-3.2s17.1-4.7 17.5-2.1c.3 1.9-1.9 11.9-3.2 17.6z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M845 439.4v7.2s-.8 13-7.5 32.9a11.22 11.22 0 01-.5 1.3 39.89 39.89 0 01-2.5 5.6c-1.9.3-3.7.5-5 .6a8.1 8.1 0 01-2.2 0c-1.6-.6 1.7-16 1.7-16l10.4-25.2.4-.1 2.3-5.5a15.37 15.37 0 012.9-.8z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M843 438.3v8.4s-.8 13-7.5 32.9a8.8 8.8 0 00-.5 1.5 6.12 6.12 0 01-.7 1.7c-.5 1.3-1.2 2.6-1.8 3.9-5.2 9.9-13.2 17-18.3 20.9a20.78 20.78 0 01-2 1.5c-1 .7-1.7 1.2-2.2 1.5l-.5.3c-4.7-2.9-18.2-3.4-18.2-3.4l-31.4 5.7a181.42 181.42 0 01-20.8 2.4l-3.6.2c-2.1.1-4.2.1-6.4.1-1.8 0-3.6 0-5.4-.1a115.27 115.27 0 01-17.6-1.7 76.63 76.63 0 01-9.5-2.1c-2.2-.6-4.4-1.4-6.6-2.2-22-8.6-16.3-29.1-12.6-38 .2-.5.4-.9.6-1.3.8-1.8 1.4-2.9 1.4-2.9l1.5-3.5 2.4-5.8.5-1.3.2-.4 1.8-4.3 25-3.2 18.4-2.4 5.6-.7 3.8-.5 7.2-.9 2.7-.3a29.22 29.22 0 015.1-.4 8.42 8.42 0 012.7.4c2 .9 17.2-1.6 17.2-1.6s11.9-3.6 22.3-2.4a114.54 114.54 0 0015.5.1l1.3-.1 1.7-.1h.4c13.3-.6 28.3-1.9 28.3-1.9z"
          transform="translate(-.05)"
        />
        <path
          d="M753.1 463.4s-12 27.3-12.5 27.8-.5 9 0 8.5 17.1-37.4 17.1-37.4zM811.2 440.3s-6.1 3.9-7.9 7.1-18.5 34.6-22.6 39.2a99.46 99.46 0 00-9.2 13.1c-.5.8-.5 6 2.4 1.1s2.2-5.8 7.9-12 12-20.2 14.4-22.9 5.8-11.2 10.1-16.2l8.1-9.5zM812.7 494.3s-4.3-2.9-8.3 2.1 8.3-2.1 8.3-2.1zM817.9 495.8s-3.5 6.1-5.2 6.6 5.2-6.6 5.2-6.6zM812.7 497.3s-2.8 4.9-5.2 4.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M793 366.1s25.7-1.1 28.3-1.9 25.1-3.8 25.1-3.8 66.9 4.7 47.8 10.4-44.9 3.3-44.9 3.3-25.3 6.6-29.1 10-32.5 3.5-32.5 3.5z"
          transform="translate(-.05)"
          fill="#efb7b9"
        />
        <path
          d="M793 366.1s25.7-1.1 28.3-1.9 25.1-3.8 25.1-3.8 66.9 4.7 47.8 10.4-44.9 3.3-44.9 3.3-25.3 6.6-29.1 10-32.5 3.5-32.5 3.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.05000000074505806}
        />
        <path
          d="M701.5 307.5s-23.5 8-12.1 28.4 26.1 30 26.1 30l37.9 26.2s15.9 9.1 23.2 5.3l11.9-1 2-31.2s-10 7.8-20.9-3-24.3-18.1-25.4-23.9-29-35.8-42.7-30.8z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M775.9 373.5s12.3 4.4 11.8 4.6l-11.8 4.5.8 16.6 16.6-.9s6.1-30.3.8-33.3l-18.3-.8z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M775.9 373.5s12.3 4.4 11.8 4.6l-11.8 4.5.8 16.6 16.6-.9s6.1-30.3.8-33.3l-18.3-.8zM751 283.7a22 22 0 00-3.8 5.9 3 3 0 00-.4 1c-8.9 0-15.3-6.9-20.8-13.1-1-1.1-3.5.6-4.4-.7a2.19 2.19 0 01-.3-.5l.3-.5c3-5.7 5.2-10.5 5.2-10.5s1 .3 2.6.9c7.4 2.6 28 10.7 21.6 17.5z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M777 259.5a30.13 30.13 0 01-29.8 30.1h-.3a30.13 30.13 0 01-22.6-10.2c-1-1.1-1.9-2.4-2.8-3.6a30.11 30.11 0 0150.7-32.5 29 29 0 014.8 16.2z"
          transform="translate(-.05)"
          fill="#efb7b9"
        />
        <path
          d="M746.4 446.2s-2.3 2.8-4.8 5.4c-1.9 2-4 3.8-5.3 4.3-3 1.1-16.8 11.5-16.8 11.5s-10.9 7.4-13.7 9.6-12.9.8-12.9.8-9.7-2.1-15.7-6c.6-1.4 1.3-2.8 2-4.2l6.3-15.3 25-3.2z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M745.9 444.3s-2.3 2.8-4.8 5.4c-1.9 2-4 3.8-5.3 4.3-3 1.1-16.8 11.5-16.8 11.5s-10.9 7.4-13.7 9.6-12.9.8-12.9.8-13.8-3-18.7-8.5c-3.4-3.8.1-10.9 2.5-14.8 1-1.7 1.8-2.8 1.8-2.8zM763.9 350.2c-8.3-.7-35.5-34-35.5-34l.6-.9 5.7-7.9H748l1.5 7.3c10.1 14.2 16.1 24.1 17.7 29.8q1.95 6.15-3.3 5.7z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M763.9 350.2c-8.3-.7-35.5-34-35.5-34l.6-.9a153.71 153.71 0 0113.7 14.3c19.9 23.4 23.8 16.9 24.5 14.8 1.3 4.2.2 6.1-3.3 5.8zM745.9 444.3s-2.3 2.8-4.8 5.4a14.28 14.28 0 01-4.2.9c-3.2-.1-10.4 4.9-10.4 4.9s-12.9-.7-15.3.6-11.8 1.6-11.8 1.6c-17.1 4.9-21.8-2.5-23.1-5 1-1.7 1.8-2.8 1.8-2.8z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M775.6 372a6.75 6.75 0 01-.2 1.4c-.1.5-.1.9-.2 1.3a21.75 21.75 0 01-2.2 7.1c-2.2 3.6-8.9 17.8-8.9 17.8l-.5 2.6-.2 1.4-.2 1.3-1.6 9.6-.7 11s-4 5.6-5.7 8-1.5 6-.8 8.5-5.6 2.9-5.6 2.9-8.7 4.3-11.9 4.1-10.4 4.8-10.4 4.8-12.9-.7-15.3.6-11.8 1.6-11.8 1.6c-18.3 5.2-22.5-3.7-23.3-5.5s3.6-9.2 3.6-9.2 1-9.3 2.9-10.1 4.3-13.1 4.3-13.1-.7-3.8.8-5.8 1.5-7.9 3.5-10.7-2.2-12.1-1.5-14.6-2.3-12.3-2.1-14.8-.6-4.6-2.5-9.7c-1.7-4.3-1.2-23.7-1-29.2v-1.5s1.7-5.5 6.2-16.4c3.4-8.3 11-11.4 14.6-12.4.6-.2 1.2-.3 1.8-.5a12.21 12.21 0 012.6.6c3.5 1.2 10.6 4.6 20.7 14a143.69 143.69 0 0112.6 13.3c22.8 26.8 24.6 14.3 24.6 14.3s1 2.3 5.7 11.4a28.19 28.19 0 012.7 15.9z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M738.2 306l-22.8-18.2s-8.2 1-11.6 14.8l23.5 20.6z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M738.2 306l-4 5.6-4.1 5.7-3.1 4.5-18.7-15.8-3.2-2.8-1.8-1.5c1.8-7.5 5.1-11.2 7.7-13a9.69 9.69 0 014-1.8z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M895.2 378.1c-19.1 5.7-44.9 3.3-44.9 3.3s-25.3 6.5-29.1 10c-2.5 2.2-15.3 3-24 3.3-4.8.2-8.5.2-8.5.2l5.3-21.5 3.1-.1c6.9-.3 23.2-1.1 25.2-1.8 2.5-.8 25.1-3.8 25.1-3.8s66.9 4.7 47.8 10.4z"
          transform="translate(-.05)"
          fill="#efb7b9"
        />
        <path
          d="M775.3 374.6a21.75 21.75 0 01-2.2 7.1c-2.2 3.6-8.9 17.8-8.9 17.8l-.9 5.4a73 73 0 01-9-4.1l-37.9-26.3s-14.7-9.6-26.1-30 12.1-28.4 12.1-28.4c13.7-5 41.5 25 42.6 30.8s14.5 13.1 25.4 23.9a19.6 19.6 0 004.9 3.8z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M775.6 372q-.15 1.5-.3 2.7a21.75 21.75 0 01-2.2 7.1c-2.2 3.6-8.9 17.8-8.9 17.8l-.5 2.6a62.69 62.69 0 01-9.5-4.3l-37.9-26.3s-14.7-9.6-26.1-30 12.1-28.4 12.1-28.4c13.7-5 41.5 25 42.6 30.8s14.5 13.1 25.4 23.9a25.17 25.17 0 005.3 4.1z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M791.3 372.5l-1.9 31.2-11.9 1c-.3.1-.5.3-.8.3-7.6 2.8-22.4-5.7-22.4-5.7l-37.9-26.2s-14.7-9.6-26.1-30 12.1-28.4 12.1-28.4c13.7-5 41.5 25 42.6 30.8s14.5 13.1 25.4 23.9a19.93 19.93 0 005.5 4 14.73 14.73 0 0015.4-.9z"
          transform="translate(-.05)"
          fill="#a36468"
        />
        <path
          d="M791.3 372.5l-1.9 31.2-11.9 1c-.3.1-.5.3-.8.3l-.8-15.2 11.8-4.5c.5-.2-11.8-4.6-11.8-4.6v-7.3a14.52 14.52 0 0015.4-.9z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M797.1 394.7c-4.8.2-8.5.2-8.5.2l5.4-21.5 3.1-.1c2 3.3 1.2 13.4 0 21.4z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M776.9 380.8s12.3 4.4 11.8 4.6l-11.8 4.5.8 16.6 16.6-.9s6.1-30.3.8-33.3l-18.3-.8z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <path
          d="M704.2 400.7s-4.1 3.9-7.5 4.9zM694.3 412.2s10.1-.4 11.3-2.4-11.3 2.4-11.3 2.4zM689.4 426.6c.6 0 12.7-1.7 13.2-3.3zM685.6 435.9c4.4-.1 11.8-4.9 11.8-4.9zM713.9 438.3s26.3 0 27.5-4.8-27.5 4.8-27.5 4.8zM733.7 370.4c.5 0 20.8 0 22.7-2.8s-22.7 2.8-22.7 2.8zM711.3 291a15.26 15.26 0 01.3 3 18.41 18.41 0 01-.3 3.3 26.93 26.93 0 01-1.9 6.1l-.2.5a20 20 0 01-1 2.1 57.85 57.85 0 01-5.2 8.6 93.82 93.82 0 01-15.7 16.4c-1 .9-2.1 1.7-3.1 2.5V332s1.7-5.5 6.2-16.4c3.4-8.3 11-11.4 14.6-12.4l-1.8-1.5c1.8-7.5 5.1-11.2 7.7-13 .1.7.3 1.4.4 2.3zM772.6 243.9a3.55 3.55 0 00-.9.4c-1.9 1-2.5 3.5-4 5.1-1.8 1.9-4.6 2.1-7.1 2.5s-5.4 1-6.8 3.1c-1 1.6-.9 3.7-1.3 5.6a1.49 1.49 0 01-.4.9 1.75 1.75 0 01-1.2.4c-5 .4-8.6-1.4-13.3-2.6-2.2-.6-4.8-.5-6.4 1s-1.9 3.6-1.9 5.7v.2a40.12 40.12 0 01.2 6 9.9 9.9 0 01-5.2 7.3 10.36 10.36 0 01-3.8 1.1 2.62 2.62 0 01-1.5-.2c.9-1.5 1.7-3 2.5-4.5a30.08 30.08 0 1150.5-32.7c.3.1.4.4.6.7z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M780.9 240a4.7 4.7 0 01-1.7 2c-2.3 1.5-5.5-.1-7.9 1.2-1.9 1-2.5 3.5-4 5.1-1.8 1.9-4.6 2.1-7.1 2.5s-5.4 1-6.8 3.1c-1 1.6-.9 3.7-1.3 5.6a1.49 1.49 0 01-.4.9 1.75 1.75 0 01-1.2.4c-5 .4-8.6-1.4-13.3-2.6-2.2-.6-4.8-.5-6.4 1s-1.9 3.6-1.9 5.7a42.37 42.37 0 01.2 6.2 10 10 0 01-9 8.4 2.27 2.27 0 01-1.8-.5 2.38 2.38 0 01-.6-1.1c-3.3-9.4-3.3-19.8-7.3-28.8a28.26 28.26 0 01-1.7-4 2.92 2.92 0 01-.2-.9 11 11 0 01-.2-1.8 2.22 2.22 0 00-1.1.5l-.3.3a5.29 5.29 0 00-.8 3.2 122.88 122.88 0 003.6 37.2 37.16 37.16 0 011.7 9.3 24.44 24.44 0 01-2.4 9.9c-6.3 14.5-18.9 25-31.4 34.6a14 14 0 003.7-10.3 3.86 3.86 0 01-3.2 2.8 11.37 11.37 0 01-4.5-.1c1.9-.6 2.7-2.9 3.2-4.9 1-4 1.9-8 2.7-12.1a78.2 78.2 0 001.8-11.8 86.89 86.89 0 00-.3-10.2 200.22 200.22 0 011-27.9c.7-8 2.1-16.6 8-22.1a34.66 34.66 0 018.4-5.2c0-1 7.3-3 8.3-3.1a4.87 4.87 0 011.2-.1 2.42 2.42 0 012.6 1.4c.4-.6.8-1.3 1.2-1.9.6-.8 1.2-1.6 1.9-2.4 3.8-4.2 8.8-7.2 13.2-10.7a39.19 39.19 0 015.2-3.9 19.17 19.17 0 017.8-2 32 32 0 0113.3 2.1c6.1 2.3 11.4 6.5 17.7 8.2a34.71 34.71 0 014.6 1.3 11.06 11.06 0 016.2 14.4 9 9 0 00-.7 1.1z"
          transform="translate(-.05)"
        />
        <g opacity={0.10000000149011612}>
          <path
            d="M679.6 329.6a14.88 14.88 0 00.9-5.9 3.86 3.86 0 01-3.2 2.8c-.4.1-.8.1-1.2.2-.5 1.6-1.3 3.1-2.8 3.6a13.6 13.6 0 004.5.1 3.7 3.7 0 001.8-.8zM781.6 232.1a11.57 11.57 0 01-1.2 4.5 5.51 5.51 0 01-1.7 2c-2.3 1.5-5.5-.1-7.9 1.2-1.9 1-2.5 3.5-4 5.1-1.8 1.9-4.6 2.1-7.1 2.5s-5.4 1-6.8 3.1c-1 1.6-.9 3.7-1.3 5.6a1.32 1.32 0 01-1.5 1.3h-.2c-5 .4-8.6-1.4-13.3-2.6-2.2-.6-4.8-.5-6.4 1s-1.9 3.6-1.9 5.7a41.47 41.47 0 01.2 6.1 9.89 9.89 0 01-9 8.4 2.27 2.27 0 01-1.8-.5 2.38 2.38 0 01-.6-1.1c-3.3-9.4-3.3-19.8-7.3-28.8-.6-1.3-1.2-2.6-1.7-4a10.89 10.89 0 01-.5-2.6 2.75 2.75 0 00-1.5.8 5.29 5.29 0 00-.8 3.2 120.3 120.3 0 001 24 122.75 122.75 0 01-.5-20.1 7.22 7.22 0 01.8-3.2 1.9 1.9 0 011.5-.8 10.89 10.89 0 00.5 2.6 28.26 28.26 0 001.7 4c4 9.1 4 19.5 7.3 28.8a2 2 0 002.4 1.6 10 10 0 009-8.4 42.83 42.83 0 00-.2-6.2c0-2.1.4-4.3 1.9-5.7 1.7-1.5 4.2-1.6 6.4-1 4.7 1.2 8.3 2.9 13.3 2.6a1.75 1.75 0 001.2-.4 1.8 1.8 0 00.4-.9c.4-1.9.3-3.9 1.3-5.5 1.4-2.2 4.2-2.8 6.8-3.1s5.4-.6 7.2-2.4c1.5-1.6 2-4.1 4-5.1 2.4-1.3 5.7.3 7.9-1.2a5.51 5.51 0 001.7-2 11.43 11.43 0 00.7-8.5zM710.6 289.6a24.44 24.44 0 01-2.4 9.9c-5.6 12.9-16.3 22.8-27.4 31.5a14.53 14.53 0 01-3.5 7c12.5-9.6 25.1-20.1 31.4-34.6a24.44 24.44 0 002.4-9.9 22 22 0 00-.5-4.4z"
            transform="translate(-.05)"
          />
        </g>
        <path
          d="M711.9 232c-.9 4.1-2.1 9.5-3.1 12.3a11 11 0 01-.2-1.8 2.22 2.22 0 00-1.1.5 99.07 99.07 0 01.7-10.5 2.42 2.42 0 012.6 1.4 7.24 7.24 0 011.1-1.9z"
          transform="translate(-.05)"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M711.4 232c-.9 4.1-2.1 9.5-3.1 12.3a11 11 0 01-.2-1.8 2.22 2.22 0 00-1.1.5 99.07 99.07 0 01.7-10.5 2.42 2.42 0 012.6 1.4 11.78 11.78 0 011.1-1.9z"
          transform="translate(-.05)"
          fill={theme.jacketColor}
        />
        <g opacity={0.699999988079071}>
          <path
            d="M915 7.5h165.7v161.1H915z"
            transform="translate(-.05)"
            fill="#2e001e"
          />
          <path
            d="M907.5 0v176.2h180.7V0zm7.6 7.5h165.7v161.2H915z"
            transform="translate(-.05)"
            fill="#ff2bc2"
          />
          <path
            d="M1038.8 74a11.08 11.08 0 00-4.4-.8c-9.5 0-15.8 7.3-15.8 19.4 0 13.9 6.5 19.4 14.9 19.4a13.18 13.18 0 005.2-.8l.1-37.2zM1005 93.3c0-17.6 11.3-31.3 29.8-31.3a25.49 25.49 0 013.9.2V42.6a.79.79 0 01.8-.8h12.1c.6 0 .8.2.8.6v68.8a61.17 61.17 0 00.4 7.4c0 .5 0 .6-.4.8a44.35 44.35 0 01-19.3 4.4c-16.4.1-28.1-10-28.1-30.5zm-25.6-12.2l21.1 40.9c.4.6.2 1.2-.5 1.2h-13.1a1.43 1.43 0 01-1.6-1c-4.8-9.9-9.7-20.3-14.8-31h-.2c-4.5 10.1-9.5 21.1-14.3 31a1.49 1.49 0 01-1.4.8h-12.5c-.8 0-.8-.6-.5-1.1l20.6-39.7L942.5 43a.63.63 0 010-.9.76.76 0 01.5-.2h13c.8 0 1.1.1 1.3.8 4.8 10 9.6 19.9 14.1 30h.2c4.4-9.9 9.2-20 13.8-29.8.4-.6.6-1 1.3-1h12.1c.6 0 .8.4.5 1.1l-19.9 38.1z"
            transform="translate(-.05)"
            fill="#ff2bc2"
          />
        </g>
        <g data-name="Layer 2">
          <g data-name="Photo Surface">
            <path
              d="M273 26.4h97.9a26.8 26.8 0 0126.8 26.8v94.1a26.8 26.8 0 01-26.8 26.8H273a26.8 26.8 0 01-26.8-26.8v-94A26.82 26.82 0 01273 26.4z"
              transform="translate(-.05)"
              fill="#001e36"
              data-name="Outline no shadow"
            />
          </g>
          <g fill="#31a8ff" data-name="Outlined Mnemonics Logos">
            <path
              d="M280.3 130.1v-65c0-.4.2-.7.6-.7 1.1 0 2.1 0 3.5-.1s3.1-.1 4.8-.1 3.5-.1 5.5-.1 3.9-.1 5.7-.1c5.2 0 9.5.6 13 2a22 22 0 018.5 5.2 20.18 20.18 0 014.6 7.2 25.81 25.81 0 011.5 8.2 23.13 23.13 0 01-3.8 13.5 21.74 21.74 0 01-10.2 7.7 40.34 40.34 0 01-14.2 2.1 26.42 26.42 0 01-3.2-.1 19.4 19.4 0 00-2.7-.1V130c.1.4-.3.8-.7.9h-12.3c-.4 0-.6-.3-.6-.8zm13.8-53.5v21.2a21.75 21.75 0 002.5.1h3.3a25.82 25.82 0 007.3-1.1 11.89 11.89 0 005.2-3.3 9.9 9.9 0 002-6.5 9.29 9.29 0 00-1.5-5.6 9.67 9.67 0 00-4.4-3.6 20.76 20.76 0 00-7.5-1.3c-1.6 0-3.1 0-4.3.1a7.07 7.07 0 00-2.6 0zM367.4 93.9a21 21 0 00-6.1-2.1 33.59 33.59 0 00-7.1-.8 12 12 0 00-3.8.4 3 3 0 00-2.5 3 3.14 3.14 0 00.6 1.6 6.84 6.84 0 002.1 1.7 45.38 45.38 0 004.5 2.1 43.13 43.13 0 019.7 4.6 14.64 14.64 0 015 5.2 14.43 14.43 0 011.5 6.5 14.06 14.06 0 01-2.5 8.4 15.64 15.64 0 01-7.1 5.6 29.46 29.46 0 01-11.4 2 50 50 0 01-8.6-.8 28 28 0 01-6.4-2c-.4-.3-.8-.7-.7-1.2v-11a.86.86 0 01.3-.6.47.47 0 01.6.1 26 26 0 007.8 3.1 30.81 30.81 0 007.5.9 11.26 11.26 0 005.2-.9 2.9 2.9 0 001.7-2.7 3.25 3.25 0 00-1.5-2.5 27.19 27.19 0 00-6.2-3 42.08 42.08 0 01-9-4.5 15.62 15.62 0 01-4.8-5.4 14.32 14.32 0 01-1.5-6.4 15.5 15.5 0 012.1-7.6 16.12 16.12 0 016.6-5.8 24.85 24.85 0 0111.2-2.2 51.23 51.23 0 017.8.6 23.93 23.93 0 015.4 1.5.9.9 0 01.6.6 2.2 2.2 0 01.1.8v10.3a.6.6 0 01-.3.6.8.8 0 01-.8-.1z"
              transform="translate(-.05)"
            />
          </g>
        </g>
      </svg>
    );
  }
}
